import { Linear, gsap, Power2 } from 'gsap';
import { ReelEngine } from '../../core/reel/engine/ReelEngine';
import { IEngineCallbacks } from '../../core/reel/engine/IEngine';
import { Helper } from '../../core/utils/Helper';

export interface IExpandAnimateConfig {
    targetSym: number;

    toSize: number;

    duration: number;
    ease?: any;
}

export class BeheadedReelEngine extends ReelEngine {
    constructor(callbacks: IEngineCallbacks, target: PIXI.Container) {
        super(callbacks, target);
    }

    // public StartRope(duration: number = 0, height:number, ease?: any): gsap.core.Timeline {
    //     this.nextTimeline = Helper.setTimeline(
    //         this.nextTimeline,
    //         new gsap.core.Timeline({
    //             paused: true,
    //             onStart: () => Helper.triggerIfExist(this.callbacks.onStartCallBack),
    //             onComplete: () => this.onStartCompleted(),
    //         })
    //     );

    //     this.nextTimeline.fromTo(
    //         this,
    //         { yPos: 0 },
    //         {
    //             duration: duration,
    //             ease: ease,
    //             yPos: -height,
    //         }
    //     );
    //     return this.nextTimeline;
    // }

    public StartRope(
        objectsToDrop: PIXI.DisplayObject[],
        dropHeight: number,
        durr: number = 0.4,
        ease?: any
    ): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(
            this.nextTimeline,
            new gsap.core.Timeline({
                paused: true,
                onStart: () => Helper.triggerIfExist(this.callbacks.onStartCallBack),
                onComplete: () => {
                    this.onStartCompleted();
                    this.yPos = -600;
                },
            })
        );

        const offsetY: number = 70;
        this.nextTimeline.to(this, { yPos: '-=' + offsetY, duration: durr, ease: ease }, 0);
        // this.nextTimeline.to(this, { yPos: 0, duration: durr*0.75 }, durr*0.25);
        for (let i = 0; i < objectsToDrop.length; i++) {
            const sym = objectsToDrop[i];
            this.nextTimeline.to(sym, { y: '+=' + dropHeight, duration: durr, ease: ease }, 0);
        }

        return this.nextTimeline;
    }

    public MoveRopeUpDown(
        objectsToDrop: PIXI.DisplayObject[],
        dropHeight: number,
        durr: number = 0.4,
        ease?: any,
        moveDown: boolean = false
    ): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(
            this.nextTimeline,
            new gsap.core.Timeline({
                onStart: () => Helper.triggerIfExist(this.callbacks.onStartCallBack),
                onComplete: () => {
                    this.onStartCompleted();
                    this.yPos = -dropHeight;
                },
            })
        );

        for (let i = 0; i < objectsToDrop.length; i++) {
            const sym = objectsToDrop[i];
            if (moveDown) {
                this.nextTimeline.to(sym, { y: '+=' + dropHeight, duration: durr, ease: ease }, 0);
            } else {
                this.nextTimeline.to(sym, { y: '-=' + dropHeight, duration: durr, ease: ease }, 0);
            }
        }
        return this.nextTimeline;
    }

    public RopeCut(
        objectsToDrop: PIXI.DisplayObject[],
        dropHeight: number,
        durr: number = 0.4,
        ease?: any
    ): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(
            this.nextTimeline,
            new gsap.core.Timeline({
                paused: true,
                onStart: () => Helper.triggerIfExist(this.callbacks.onStartCallBack),
                onComplete: () => this.onStartCompleted(),
            })
        );
        this.nextTimeline.to(this, { yPos: '-=' + 10, duration: durr * 0.25, ease: ease }, 0);
        this.nextTimeline.to(this, { yPos: 0, duration: durr * 0.75 }, durr * 0.25);

        for (let i = 0; i < objectsToDrop.length; i++) {
            const sym = objectsToDrop[i];
            this.nextTimeline.to(sym, { y: '+=' + dropHeight, duration: durr, ease: ease }, 0);
        }

        return this.nextTimeline;
    }

    public RopeDrop(duration: number, ease?: any): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(
            this.nextTimeline,
            new gsap.core.Timeline({
                paused: true,
                onStart:() => this.onStopStarted(),
                onComplete: () => this.onSpinStopCompleted(),
            })
        );

        this.nextTimeline.to(this, { yPos: 0, duration: duration, ease: ease });
        this.nextTimeline.add(() => this.onBounce(), duration * 0.6);

        return this.nextTimeline;
    }

    public Stop(duration: number = 0, ease?: any): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(
            this.nextTimeline,
            new gsap.core.Timeline({
                paused: true,
                onComplete: () => this.onSpinStopCompleted(),
            })
        );

        this.nextTimeline.to(this, {
            duration: duration,
            ease: ease,
            yPos: 0,
        });

        this.nextTimeline.add(() => Helper.triggerIfExist(this.callbacks.onStopCallback), 0);
        this.nextTimeline.add(() => this.onBounce(), duration * 0.6);

        return this.nextTimeline;
    }

    public Idle(): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(this.nextTimeline, new gsap.core.Timeline());
        return this.nextTimeline;
    }

    protected onBounce(): void {
        Helper.triggerIfExist(this.callbacks.onBounceStartCallback);
    }

    protected onStartCompleted(): void {
        Helper.triggerIfExist(this.callbacks.onCompletedStartCallback);
    }

    protected onStopStarted(): void {
        Helper.triggerIfExist(this.callbacks.onStopCallback);
    }

    protected onSpinStopCompleted(): void {
        this.yPos = 0;
        Helper.triggerIfExist(this.callbacks.onCompletedStopCallback);
    }

    protected onNudgeCompleted(): void {
        this.yPos = 0;
        Helper.triggerIfExist(this.callbacks.onCompletedNudgeCallback);
    }
}
